import { createFileRoute, notFound } from "@tanstack/react-router";

// The old route is gone. Return a standard 404 with no hint anything
// ever lived here. Do not redirect — redirects leak existence.
export const Route = createFileRoute("/admin")({
  beforeLoad: () => {
    throw notFound();
  },
  notFoundComponent: () => (
    <div className="flex min-h-screen items-center justify-center bg-background text-foreground">
      <div className="text-center">
        <h1 className="font-display text-6xl font-bold">404</h1>
        <p className="mt-2 text-muted-foreground">Page not found.</p>
      </div>
    </div>
  ),
  component: () => null,
});
